import HeaderHero from "../HeaderHero";
import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import GPayLogo from "../assets/img/icon/Google-Pay-logo.png";
import allpayApp from "../assets/img/icon/payment-logo.png";
import Scanner1000 from "../assets/Scanner/GPay_DomeHelp.png";
import Swal from "sweetalert2";
function Checkout() {
  const { productId } = useParams();
  const [FullName, setFullName] = useState("");
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Note, setNote] = useState("");
  const [Products, setProducts] = useState([]);
  const [showFisrtModel, setshowFisrtModel] = useState(0);
  const [showSecondModel, setshowSecondModel] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [OrderId, setOrderId] = useState("");
  const [TransactionId, setTransactionId] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const TotalAmount = Products.reduce(
    (sum, product) => sum + Number(product.currentAmount),
    0,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    GetOrderDetails();
  },[location.pathname]);

  function GetOrderDetails() {
    // Buy Now
    if (productId) {
      fetch(
        `https://api.domehelp.com/ProductInformation/GetProductDetailByID?ID=${productId}`,
        {
          method: "GET",
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Getting Error.");
          }
          return response.json();
        })
        .then((result) => {
          if (result.status === 1) {
            setProducts([result.data]); 
          }
        })
        .catch((error) => {
          Swal.fire("Warning!", error.toString(), "warning");
        });

      return;
    }

    // Navigate from Cart Checkout
    const ids = JSON.parse(localStorage.getItem("cart")) || [];

    if (ids.length === 0) {
      setProducts([]);
      return;
    }

    fetch("https://api.domehelp.com/ProductInformation/GetProductsByIDs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ids),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Getting Error.");
        }
        return response.json();
      })
      .then((result) => {
        if (result.status === 1) {
          setProducts(result.data);
        } else {
          setProducts([]);
        }
      })
      .catch((error) => {
        Swal.fire("Warning!", error.toString(), "warning");
      });
  }

  //   function CreatenewOrder() {
  //     if (FullName.trim() === "") {
  //       Swal.fire("Warning!", "Please Enter Your Full Name.", "warning");
  //       return false;
  //     }

  //     if (Phone.trim() === "") {
  //       Swal.fire("Warning!", "Enter your correct Phone Number.", "warning");
  //       return;
  //     }
  //     if (Phone.length !== 10 || Phone.trim() <= 0) {
  //       Swal.fire("Warning!", "Enter your correct Phone Number.", "warning");
  //       return;
  //     }
  //     if (Email.trim() === "") {
  //       Swal.fire("Warning!", "Please Enter Your Email.", "warning");
  //       return false;
  //     }
  //     let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //     if (!regex.test(Email)) {
  //       Swal.fire("Warning!", "Please Enter Your Correct Email.", "warning");
  //       return false;
  //     }

  //     let fd = new FormData();
  //     fd.append("UserFullName", FullName);
  //     fd.append("UserMobile", Phone);
  //     fd.append("UserEmail", Email);
  //     fd.append("ResponseNotes", Note);
  //     fd.append("ProductId", productId);
  //     fd.append("OQuantity", quantity);
  //     fd.append("Amount", CurrentAmount * quantity);

  //     fetch(`https://api.domehelp.com/ProductInformation/CreateNewOrder`, {
  //       method: "POST",
  //       body: fd,
  //     })
  //       .then((response) => {
  //         if (!response.ok) {
  //           Swal.fire("Warning!", "getting Error.", "warning");
  //           return false;
  //         } else {
  //           return response.json();
  //         }
  //       })
  //       .then((result) => {
  //         if (result.status === 1) {
  //           setOrderId(result.orderId);
  //           setshowFisrtModel(1);
  //           //ProceedPayment(result.orderId, result.amount, result.userId);
  //         } else {
  //           Swal.fire("Warning!", "getting Error.", "warning");
  //         }
  //       });
  //   }

  // function ProceedPayment(OrderId, Amount, CustomerId) {
  //     let fd = new FormData();
  //     fd.append("orderId", OrderId);
  //     fd.append("amount", Amount);
  //     fd.append("customerId", CustomerId);
  //     fetch(`https://api.domehelp.com/InitiateJuspayPayment/Post`, {
  //         method: "POST",
  //         body: fd,
  //     }).then((response) => {
  //         if (!response.ok) {
  //             Swal.fire("Warning!", "getting Error.", "warning");
  //             return false;
  //         }
  //         else {
  //             return response.json();
  //         }
  //     }).then((result) => {
  //         const orderDetails = {
  //             orderId: OrderId,
  //             productId: productId
  //         };

  //         localStorage.setItem('orderDetails', JSON.stringify(orderDetails));
  //         setFullName("");
  //         setPhone("");
  //         setEmail("");
  //         setNote("");
  //         window.open(result.paymentLinks.web, '_blank');
  //     })
  // }

  function PaymentTransactionIDConfirm() {
    if (TransactionId.trim === "") {
      Swal.fire("Warning!", "Please Enter Your Transaction ID.", "warning");
      return false;
    }
    if (TransactionId.length !== 12) {
      Swal.fire("Warning!", "Please Enter Correct Transaction ID.", "warning");
      return false;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Please ensure that your transaction ID is correct before confirming.",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(
          `https://api.domehelp.com/ProductInformation/UpdateTransaction?OrderId=${OrderId}&TransactionId=${TransactionId}`,
          {
            method: "POST",
          },
        )
          .then((response) => {
            if (!response.ok) {
              Swal.fire("Warning!", "getting Error.", "warning");
              return false;
            } else {
              return response.json();
            }
          })
          .then((results) => {
            if (results.status === 1) {
              OrderReceivedPending(OrderId);
            } else {
              Swal.fire("Warning!", "getting Error.", "warning");
              return false;
            }
          });
      }
    });
  }

  function CancelPayment() {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to Cancel this Order Payment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setshowFisrtModel(0);
        setFullName("");
        setPhone("");
        setEmail("");
        setNote("");
      }
    });
  }
  function OrderReceivedPending(OrderId) {
    fetch(
      `https://api.domehelp.com/ProductInformation/OrderReceivedPending?OrderId=${OrderId}`,
      {
        method: "POST",
      },
    )
      .then((response) => {
        if (!response.ok) {
          Swal.fire("Warning!", "getting Error.", "warning");
          return false;
        } else {
          return response.json();
        }
      })
      .then((results) => {
        if (results.status === 1) {
          const orderDetails = {
            orderId: OrderId,
          };
          localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
          navigate(`/ProductOrderDone`);
        } else {
          Swal.fire("Warning!", "getting Error.", "warning");
          return false;
        }
      });
  }
  return (
    <>
      <HeaderHero Name={"Checkout"} />
      <div className="container checkout-page">
        <div className="row justify-content-center mt-5 mb-5">
          {/* Billing */}
          <div className="col-lg-8 col-10">
            <div className="checkout-card">
              <div className="mb-4">
                <h3 className="checkout-heading">Billing Details</h3>
                <p className="checkout-subheading">
                  Enter your billing information below.
                </p>
              </div>

              <Form>
                <div className="row">
                  <div className="col-12 mb-3">
                    <Form.Group controlId="formFirstName">
                      <Form.Label>Full Name *</Form.Label>

                      <Form.Control
                        type="text"
                        name="FullName"
                        value={FullName}
                        placeholder="John Doe"
                        onChange={(e) => setFullName(e.target.value)}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-12 mb-3">
                    <Form.Group controlId="formLastName">
                      <Form.Label>Phone *</Form.Label>

                      <Form.Control
                        type="number"
                        name="Phone"
                        value={Phone}
                        placeholder="9876543210"
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-12 mb-4">
                    <Form.Group controlId="formMobile">
                      <Form.Label>Email Address *</Form.Label>

                      <Form.Control
                        type="email"
                        name="Email"
                        value={Email}
                        placeholder="name@email.com"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>

                    <small className="text-muted">
                      Your product download link will be sent to this email.
                    </small>
                  </div>
                </div>
              </Form>

              <hr className="my-4" />

              <div>
                <h5 className="section-title">Additional Information</h5>

                <Form.Group>
                  <Form.Label>Order Notes</Form.Label>

                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={Note}
                    placeholder="Optional"
                    onChange={(e) => setNote(e.target.value)}
                  />
                </Form.Group>
              </div>
            </div>
          </div>

          {/* Order */}
          <div className="col-lg-4 col-10">
            <div className="checkout-card order-summary">
              <h3 className="checkout-heading">Your Order</h3>

              {Products.map((product) => (
                <div className="order-item" key={product.jobID}>
                  <div>
                    <h6>{product.jobName}</h6>
                    <small>Quantity : 1</small>
                  </div>

                  <strong>₹{product.currentAmount}</strong>
                </div>
              ))}

              <div className="summary-row">
                <span>Subtotal</span>
                <span>₹{TotalAmount}</span>
              </div>

              <div className="summary-row">
                <span>Taxes</span>
                <span>Included</span>
              </div>

              <div className="summary-row total">
                <strong>Total</strong>
                <strong>₹{TotalAmount}</strong>
              </div>

              {/* <div className="payment-box mt-4">
                <div className="payment-title">
                  <input type="radio" checked readOnly />
                  <span>Secure Google Pay Payment</span>
                </div>

                <img src={GPayLogo} alt="Google Pay" className="gpay-logo" />

                <p>Supports UPI, Debit Cards, Credit Cards and Net Banking.</p>
              </div> */}

              <button
                type="button"
                className="btn checkout-btn w-100 mt-3"
                // onClick={CreatenewOrder}
              >
                Continue to Payment
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          showFisrtModel === 0 ? `modal fade d-none` : `modal fade show d-block`
        }
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={showFisrtModel === 0 ? `true` : `false`}
        style={{ backgroundColor: "#000000b0" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content custom-content">
            <div
              className="modal-header bg-primary"
              style={{
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                position: "relative",
                padding: "10px 15px 5px 15px",
              }}
            >
              <div style={{ width: "100%" }}>
                <h5 style={{ fontSize: "16px", color: "white" }}>Domehelp</h5>
                <h5
                  style={{
                    fontSize: "12px",
                    color: "white",
                    backgroundColor: "#6b9de9cc",
                    width: "120px",
                    padding: "5px",
                    borderRadius: "2px",
                  }}
                >
                  Order ID : #{OrderId}
                </h5>
              </div>
              <button
                type="button"
                className="custom-close-btn"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  CancelPayment();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body p-2">
              <div
                style={{
                  border: "1px solid #80808047",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    margin: "auto",
                    border: "1px solid #80808047",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <img src={Scanner1000} alt="" />
                </div>
                {/* <h3 style={{ backgroundColor: "#80808021", color: "#00000066", width: "200px", fontSize: "20px", margin: "auto", marginTop: "10px", marginBottom: "10px" }}>igjoinyhitu</h3> */}
                <p style={{ fontSize: "13px", marginBottom: "0px" }}>
                  Please scan the QR code with any UPI app to pay for your
                  order.Kindly check your email after payment,and be sure to
                  check your spam folder as well.If you do not receive any
                  mail,please contact us immediately at contact@domehelp.com
                </p>
                <img
                  src={allpayApp}
                  alt="gpay"
                  style={{ width: "200px", height: "60px" }}
                />
              </div>
            </div>
            <div
              className="modal-footer p-3"
              style={{ justifyContent: "space-between" }}
            >
              <h6>₹{TotalAmount}</h6>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setshowFisrtModel(0);
                  setshowSecondModel(1);
                }}
              >
                Proceed to Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          showSecondModel === 0
            ? `modal fade d-none`
            : `modal fade show d-block`
        }
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={showSecondModel === 0 ? `true` : `false`}
        style={{ backgroundColor: "#000000b0" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content custom-content">
            <div
              className="modal-header bg-primary"
              style={{
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                position: "relative",
                padding: "10px 15px 5px 15px",
              }}
            >
              <div style={{ width: "100%" }}>
                <h5 style={{ fontSize: "16px", color: "white" }}>Domehelp</h5>
                <h5
                  style={{
                    fontSize: "12px",
                    color: "white",
                    backgroundColor: "#6b9de9cc",
                    width: "120px",
                    padding: "5px",
                    borderRadius: "2px",
                  }}
                >
                  Order ID : #{OrderId}
                </h5>
              </div>
              <button
                type="button"
                className="custom-close-btn"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setshowFisrtModel(1);
                  setshowSecondModel(0);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body p-2">
              <div
                style={{
                  border: "1px solid #80808047",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                <h3
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                    margin: "10px",
                  }}
                >
                  Enter 12-digit Transaction/UTR/Reference ID:
                </h3>
                <input
                  className="my-2"
                  type="text"
                  style={{ border: "1px solid black" }}
                  value={TransactionId}
                  onChange={(e) => {
                    setTransactionId(e.target.value);
                  }}
                />
                <p
                  style={{
                    fontSize: "13px",
                    marginBottom: "0px",
                    textAlign: "center",
                  }}
                >
                  Please ensure that the amount has been deducted from your
                  account before clicking "Confirm". We will verfiy your
                  transaction once submitted.
                </p>
                <img
                  src={allpayApp}
                  alt="gpay"
                  style={{ width: "200px", height: "60px" }}
                />
              </div>
            </div>
            <div
              className="modal-footer p-3"
              style={{ justifyContent: "space-between" }}
            >
              <button
                type="button"
                style={{ background: "none", border: "none" }}
                onClick={() => {
                  setshowFisrtModel(1);
                  setshowSecondModel(0);
                }}
              >
                Back
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => {
                  PaymentTransactionIDConfirm();
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Checkout;
